import logo from './showcase.png';
import appStore from './app_store.png';
import googlePlay from './google_play.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="Content">
          <div className="Left">
            <img src={logo} alt="logo" className="Logo" />
          </div>
          <div className="Right">
            <div className="Store-badges">
              <a href="https://apps.apple.com/us/app/hang-10-app/id6748242464" target="_blank">
                <img src={appStore} alt="App Store" className="Store-icon" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.hang10.android&hl=en_GB&pli=1" target="_blank">
                <img src={googlePlay} alt="Google Play" className="Store-icon" />
              </a>
            </div>
            <div className="Links">
              <a href="/contact">Contact Us</a>
              <a href="/safety-standards">Safety Standards</a>
              <a href="/privacy-policy">Privacy Policy</a>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
